/* eslint-disable import/no-anonymous-default-export */
export default {
  "exception.back": "Volver al Inicio",
  "exception.403.title": "Lo siento, no tienes acceso a esta página",
  "exception.404": "404",
  "exception.404.title": "Este enlace parece no existir más o estás perdido",
  "exception.404.message":
    "Ponte en contacto con quien te envió este enlace y solicita que lo verifique",
  "exception.500.title": "Lo siento, el servidor está reportando un error",
};
